import PageHead from '@/src/page-head'
import { useAsync } from 'react-async'
import { fetchUserAndCourseSummaries } from '@/src/ck'
import Loading from '@/courses/Loading'
import CourseSummary from '@/courses/CourseSummary'
import Nav from '@/courses/Nav'
import Footer from '@/courses/Footer'
import styles from 'styles/Courses.module.css'
import Author from '@/courses/Author'
import CourseIdea from '@/components/CourseIdea'
import CourseFAQ from '@/components/CourseFAQ'
import CourseQuote from '@/components/CourseQuote'
import ErrorMessage from '@/courses/Error'
import * as Sentry from '@sentry/nextjs'

function Courses() {
  const { data, error, isPending } = useAsync(fetchUserAndCourseSummaries)

  if (data) {
    const { courses } = data.courseRes
    // console.log(data)

    // remove all courses that CourseKit has marked "test: true"
    const filteredCourses = courses.filter((course) => {
      const isTest = course.meta?.test === true
      return !isTest
    })
    const sortedCourses = filteredCourses.sort((c1, c2) => {
      return c1.meta?.listPosition - c2.meta?.listPosition
    })
    // insert a fundamentals course hosted by BlazeMeter University at the end
    // sortedCourses.push({
    //   id: 'cyv10',
    //   title: 'Cypress Version 10: Fundamentals',
    //   // one needs to enroll through the BlazeMeter University
    //   enrolled: 'Enroll via BlazeMeter University',
    //   meta: {
    //     slug: 'cyv10',
    //     url: 'https://www.blazemeter.com/university',
    //     description: `
    //     A FREE course covering End-to-End and Component testing using the newly released Cypress v10.
    //     This course is a must if you are just starting to learn Cypress or a seasoned pro looking to
    //     fill the gaps in your knowledge. The course is hosted by BlazeMeter University. Create a free
    //     BlazeMeter University account, log in, and enroll in the course.
    //     `,
    //     priceMessage: 'Course is 100% FREE',
    //     showEnrolled: false,
    //     published: 'published July 2022',
    //     tags: 'free, beginner',
    //   },
    // })

    return (
      <div className="page">
        <PageHead
          title="Cypress.io Tips Courses"
          description="Cypress.io courses by Gleb Bahmutov"
          image="https://cypress.tips/courses.png"
        />

        <Nav />
        <header>
          <h1 className={styles.Header}>Cypress.io Courses</h1>
        </header>
        {sortedCourses.map((course) => {
          return <CourseSummary course={course} key={course.id} />
        })}

        <Author />
        <CourseFAQ />
        <CourseIdea />
        <Footer />
        <CourseQuote />
      </div>
    )
  }
  if (error) {
    Sentry.captureException(error)
    return (
      <div className="page">
        <PageHead
          title="Cypress.io Tips Courses"
          description="Cypress.io courses by Gleb Bahmutov"
          image="https://cypress.tips/courses.png"
        />
        <ErrorMessage />
      </div>
    )
  }
  if (isPending) {
    return (
      <div className="page">
        <PageHead
          title="Cypress.io Tips Courses"
          description="Cypress.io courses by Gleb Bahmutov"
          image="https://cypress.tips/courses.png"
        />
        <Loading />
      </div>
    )
  }
}

export default Courses
